export default "__VITE_ASSET__TmDAqKa8__"